import { useCountryConfig } from 'modules/common/hooks/useCountryConfig'

export const useIsSponsorshipEnabled = () => {
  const countryConfig = useCountryConfig()

  return {
    isSponsorshipEnabled: countryConfig.isSponsorshipEnabled,
  }
}
